export default __webpack_public_path__ + "f452398b8226e9ba4774797f5a621a47.svg";